<div>
  <input type="file" (change)="onFileChange($event)" accept="image/*" />
  @if (imagePreview) {
    <div class="image-preview">
      <img [src]="imagePreview" alt="Image preview" />
    </div>
  }
</div>
